import React from 'react';
import classnames from 'classnames';
import { Calendar, type CalendarProps } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { Colors } from '@/styles/colors';
import styles from './Picker.module.scss';

export interface CalendarPickerProps extends CalendarProps {
  className?: string;
  date: CalendarProps['date'];
  onClose?: () => void;
}
export const CalendarPicker: React.FC<CalendarPickerProps> = ({ className, ranges, ...rest }) => (
  <Calendar
    ranges={ranges}
    rangeColors={Array(ranges?.length || 1).fill(Colors.Sienna)}
    className={classnames(styles.root, className)}
    color={Colors.Sienna}
    {...rest}
  />
);
